export default __webpack_public_path__ + "static/assets/med_pill_triangle_in_L1_solid_x_01_f.d2f7fb20.png";